class PopoutCart {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        document.addEventListener('popout-cart-shown', e => {
            document.body.classList.add('no-scroll')
            this._elem.classList.add('shown')
        })

        const urlSearchParams = new URLSearchParams(window.location.search)
        if (urlSearchParams.get('show-cart')) {
            document.dispatchEvent(new Event('popout-cart-shown'))
        }
    }
}

export default PopoutCart



// WEBPACK FOOTER //
// ./resources/scripts/components/PopoutCart.js